<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 px-4 py-12">
      <section class="mx-auto w-full max-w-3xl space-y-6">
        <div class="space-y-3 text-center">
          <h1 class="text-3xl font-semibold text-slate-900 sm:text-4xl">Hinnakiri</h1>
          <p class="text-sm text-slate-500 sm:text-base">
            Hinnad sisaldavad standardseid rehvitöid. Täpsem pakkumine sõltub sõiduki tüübist ja töö mahust.
          </p>
        </div>

        <div class="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-900/5 sm:p-8">
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-slate-200 text-left">
              <thead class="bg-slate-50/80">
                <tr>
                  <th class="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
                    Teenus
                  </th>
                  <th class="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-right text-slate-500">
                    Hind
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-100 text-sm text-slate-700">
                <tr v-for="(item, index) in items" :key="index" class="hover:bg-slate-50">
                  <td class="px-4 py-3 font-medium">{{ item.name }}</td>
                  <td class="px-4 py-3 text-right text-brand">
                    {{ item.price }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="mt-4 text-xs text-slate-500">
            Hinnad on indikatiivsed ja ei sisalda võimalikke lisatarvikuid. Küsi personaalset pakkumist, et leida parim lahendus.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hinnakiri",
  data() {
    return {
      items: [
        { name: "Item 1", price: "$10" },
        { name: "Item 2", price: "$20" },
        { name: "Item 3", price: "$30" },
      ],
    };
  },
};
</script>

<style scoped></style>
